module.exports = __webpack_public_path__ + "media/images/athletes/1491-b4d881e14b80d4f3ac9ab4afda743442.png";